// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__PwBM0","content":"GlobalSearch_content__2bdF_"};